import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface Redirects {
  redirects: { from: string; to: string }[];
}

let cache: Promise<Redirects> | null = null;
function loadRedirects(): Promise<Redirects> {
  if (!cache) {
    cache = fetch("/data/redirects.json")
      .then((r) => (r.ok ? r.json() : { redirects: [] }))
      .catch(() => ({ redirects: [] }));
  }
  return cache;
}

/**
 * When a recipe id matches an entry in /data/redirects.json (from -> to),
 * replace the current route with the new id. Keeps published URLs alive forever.
 */
export function useRecipeRedirect() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    loadRedirects().then((data) => {
      if (cancelled) return;
      const match = data.redirects.find((r) => r.from === id || r.from.endsWith(`/${id}`));
      if (match) {
        const toId = match.to.includes("/") ? match.to.split("/").pop()! : match.to;
        navigate(`/recipes/${toId}`, { replace: true });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);
}
